import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Header.css';

const NAV_LINKS = [
  { type: 'anchor', id: 'hero', label: 'Inicio' },
  { type: 'anchor', id: 'beneficios', label: 'Beneficios' },
  { type: 'anchor', id: 'instalaciones', label: 'Estudio' },
  { type: 'route', to: '/modalidad-satelite', label: 'Modalidad satélite' },
  { type: 'route', to: '/galeria', label: 'Galería' },
  { type: 'anchor', id: 'testimonios', label: 'Testimonios' },
];

function Header() {
  const { pathname } = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const isHome = pathname === '/';

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const handleNavClick = () => setMobileOpen(false);

  const sectionHref = (id) => (isHome ? `#${id}` : `/#${id}`);

  return (
    <nav className="tm-nav">
      <div className="tm-container tm-nav-container">
        <Link to="/" className="logo-hover tm-nav-logo">
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={`${process.env.PUBLIC_URL}/logo-tmstudio.png`}
              alt="TM Studio - Agencia Elite de Modelos"
              className="tm-nav-logo-img"
              onError={(e) => {
                e.target.style.display = 'none';
                const fb = e.target.nextElementSibling;
                if (fb) fb.style.display = 'inline';
              }}
            />
            <span id="logo-fallback" className="tm-nav-logo-fallback">
              <span style={{ color: '#fff' }}>TM</span>
              <span style={{ color: 'var(--gold)' }}>Studio</span>
            </span>
          </span>
          <div className="tm-nav-logo-text">
            <span className="tm-nav-logo-title">
              <span style={{ color: '#fff' }}>TM</span>
              <span className="gold-gradient-text">Studio</span>
            </span>
            <span className="tm-nav-tagline">
              Elite Modeling Agency
            </span>
          </div>
        </Link>

        <div className="tm-nav-desktop">
          <div className="tm-nav-links">
            {NAV_LINKS.map((item) =>
              item.type === 'route' ? (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`tm-nav-link ${item.to === '/modalidad-satelite' ? 'tm-nav-link--featured' : ''}`}
                >
                  <span className="tm-nav-link-label">{item.label}</span>
                  {item.to === '/modalidad-satelite' && (
                    <span className="tm-nav-link-badge" aria-label="Nuevo">
                      NEW
                    </span>
                  )}
                </Link>
              ) : (
                <a key={item.id} href={sectionHref(item.id)} className="tm-nav-link">
                  {item.label}
                </a>
              )
            )}
          </div>
          <Link
            to="/registro"
            className="btn-hover gold-gradient-bg tm-nav-cta"
          >
            Únete Ahora
            <span className="material-symbols-outlined" style={{ fontSize: '1.125rem' }}>arrow_forward</span>
          </Link>
        </div>

        <button
          type="button"
          aria-label="Abrir menú"
          className="tm-nav-mobile-btn"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          <span className="material-symbols-outlined tm-nav-mobile-btn-icon">menu</span>
        </button>
      </div>

      {mobileOpen && (
        <div
          className="tm-nav-overlay"
          role="dialog"
          aria-modal="true"
          aria-label="Menú de navegación"
        >
          <button
            type="button"
            aria-label="Cerrar menú"
            onClick={() => setMobileOpen(false)}
            className="tm-nav-overlay-close"
          >
            <span className="material-symbols-outlined tm-nav-overlay-close-icon">close</span>
          </button>
          {NAV_LINKS.map((item) =>
            item.type === 'route' ? (
              <Link
                key={item.to}
                to={item.to}
                onClick={handleNavClick}
                className={`tm-nav-mobile-link ${item.to === '/modalidad-satelite' ? 'tm-nav-mobile-link--featured' : ''}`}
              >
                <span className="tm-nav-mobile-link-row">
                  <span>{item.label}</span>
                  {item.to === '/modalidad-satelite' && (
                    <span className="tm-nav-mobile-badge" aria-label="Nuevo">
                      NEW
                    </span>
                  )}
                </span>
              </Link>
            ) : (
              <a
                key={item.id}
                href={sectionHref(item.id)}
                onClick={handleNavClick}
                className="tm-nav-mobile-link"
              >
                {item.label}
              </a>
            )
          )}
          <Link
            to="/registro"
            onClick={handleNavClick}
            className="btn-hover gold-gradient-bg tm-nav-mobile-cta"
          >
            Únete Ahora
            <span className="material-symbols-outlined">arrow_forward</span>
          </Link>
        </div>
      )}
    </nav>
  );
}

export default Header;

